import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { InputContentPosition, InputHelpMessagePosition, } from '@kubit/web-ui-components/input/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { IconHighlightedVariantType, InputVariantType, TextVariantType } from '../variants';
export const withDropdownCommonStyles = (FOUNDATIONS, FONT) => ({
    inputVariant: InputVariantType.INPUT_PHONE,
    affixContainer: {
        display: 'inline-flex',
        justify_content: 'center',
        align_items: 'center',
        width: 'auto',
        background_color: 'inherit',
        height: FOUNDATIONS.spacing_400,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
        gap: FOUNDATIONS.spacing_100,
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        margin_right: FOUNDATIONS.spacing_150,
    },
    affixContainerPosition: InputContentPosition.OUT,
    affix: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    affixIcon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
    },
    affixIconHighlighted: {
        variant: IconHighlightedVariantType.CIRCLE,
        size: IconHighlightedSizeType.EXTRA_SMALL,
        backgroundColor: '#eae5ff',
    },
    affixIconContainer: {
        position: 'relative',
        overflow: 'hidden',
    },
    helpMessage: {
        position: InputHelpMessagePosition.BOTTOM,
    },
    bottomExtraStyles: {},
    topExtraStyles: {},
    errorMessageContainer: {
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_100,
        padding_left: FOUNDATIONS.spacing_00,
    },
    errorMessageIcon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
    },
});
export const withoutDropdownCommonStyles = (FOUNDATIONS, FONT) => ({
    ...withDropdownCommonStyles(FOUNDATIONS, FONT),
    affixContainer: {
        ...withDropdownCommonStyles(FOUNDATIONS, FONT).affixContainer,
        height: FOUNDATIONS.spacing_450,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
    },
});
export const withoutDropdownV2CommonStyles = (FOUNDATIONS, FONT) => ({
    ...withDropdownCommonStyles(FOUNDATIONS, FONT),
    affixContainer: {
        ...withDropdownCommonStyles(FOUNDATIONS, FONT).affixContainer,
        height: FOUNDATIONS.spacing_450,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
    },
    phonePrefixContainer: {
        display: 'flex',
        min_width: FOUNDATIONS.size_675,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
        justify_content: 'center',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_100,
        //
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        background_color: FOUNDATIONS.color_comp_forms_input_bgprefixsufix,
        //
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
        font_family: FOUNDATIONS.font_family_paragraph,
        font_size: FOUNDATIONS.font_size_paragraph_medium,
        font_weight: FOUNDATIONS.font_weight_caption_medium_regular,
        line_height: FOUNDATIONS.font_line_height_paragraph_medium,
    },
    phonePrefixContainerLeftIcon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
    },
});
export const withoutDropdownDisabledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...withoutDropdownCommonStyles(FOUNDATIONS, FONT),
    affixContainer: {
        ...withoutDropdownCommonStyles(FOUNDATIONS, FONT).affixContainer,
        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
    },
});
//# sourceMappingURL=commonStyles.js.map